import { Grid, SingleSelect, Button } from "designSystem/index";
import React, { SyntheticEvent } from "react";
import { items } from "designSystemLegacy/data";
import { action, makeObservable, observable } from "mobx";
import { ComponentItem } from "designSystem/types/component-item-types";

class State {
	@observable item: ComponentItem =  items[0];
	@action setItem = (ev: SyntheticEvent, item: ComponentItem) => {
		this.item = item;
	};
	@action reset= () => {
		this.item = items[0];
	};
	constructor() {
		makeObservable(this);
	}
}
const state = new State();

export default () => {
	const { item, reset, setItem } = state;

	return (
		<Grid
			container
			direction="column"
			spacing={4}
		>
			<Grid item>
				<Button design="secondary" onClick={reset}>Reset selection to first item</Button>				
				<SingleSelect
				  	onChange={setItem}
					options={items}
					value={item}
				/>
			</Grid>
		</Grid>
	);
};